import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../auth/auth.repository';
import { AppConfigService } from 'app/core/config/app-config.service';

/**
 * Adds JWT Authorization header to HTTP requests to the API URL.
 *
 * @param req HttpRequest instance
 * @param next Next handler in the Http pipeline
 * @returns An Observable of the Http event stream
 */
export const JwtInterceptor = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const authRepository = inject(AuthRepository);
  const appConfig = inject(AppConfigService);

  const serverUrl = appConfig.get<string>('serverUrl', '');
  const apiBase = appConfig.get<string>('api_baseurl', '').replace(/\/$/, '');
  const isApiUrl = req.url.startsWith(serverUrl) || (!!apiBase && req.url.startsWith(apiBase));
  const isRefreshEndpoint = req.url.includes('/refresh-token');
  
  if (isApiUrl && !isRefreshEndpoint) {
    const token = authRepository.getAccessToken();
    const api_key = appConfig.get<string>('api_key_studema_settings', '');

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'X-APIKEY': api_key,
        },
      });
    }
  }

  return next(req);
};
